import {createStore, combineReducers, applyMiddleware} from "redux"
import thunk from "redux-thunk"
import {composeWithDevTools} from "redux-devtools-extension"
import { productReducer } from "./reducers/productReducer"
import { userReducer } from "./reducers/userReducer"
import { orderReducer } from "./reducers/orderReducer"
import { cartReducer } from "./reducers/cartReducer"
import { addressReducer } from "./reducers/addressReducer"

const reducer = combineReducers({
    products:productReducer,
    user: userReducer,
    orders: orderReducer,
    cart: cartReducer,
    address: addressReducer
})

let initialState={}

const middleware = [thunk]

const store = createStore(reducer, initialState, composeWithDevTools(applyMiddleware(...middleware)))

export default store;